export enum GenderOptions {
	Male = 'male',
	Female = 'female',
	NonBinary = 'nonBinary',
	Other = 'other',
}
